import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FormInputs } from "components/FormInputSelect";
import CustomButton from "components/CustomButton";

const PHONE_MIN_LENGTH = 8;
const ONLY_NUMBER = /^\d+$/;

/**
 * Modal wajib untuk melengkapi nomor telepon. Tidak bisa ditutup: selama nomor
 * telepon belum terisi, user tidak boleh melanjutkan ke halaman mana pun.
 */
const ModalPhoneNumber = ({ isOpen, isSaving, errorMessage, onSubmit }) => {
  const [phoneNumber, setPhoneNumber] = useState("");

  // Ikuti pola input telepon di halaman Profile: hanya menerima angka.
  const onChange = (e) => {
    const { value } = e.target;
    if (value === "" || ONLY_NUMBER.test(value)) {
      setPhoneNumber(value);
    }
  };

  const isPhoneValid = phoneNumber.length >= PHONE_MIN_LENGTH;
  const isSubmitDisabled = !isPhoneValid || isSaving;

  const handleSubmit = () => {
    if (isSubmitDisabled) return;
    onSubmit(phoneNumber);
  };

  return (
    <Modal isOpen={isOpen} centered backdrop="static" keyboard={false}>
      <ModalHeader>Lengkapi Nomor Telepon</ModalHeader>
      <ModalBody>
        <p style={{ marginBottom: "16px" }}>
          Nomor telepon kamu belum terisi. Mohon lengkapi terlebih dahulu untuk
          melanjutkan.
        </p>
        <div className="text-input" style={{ marginBottom: "8px" }}>
          <span style={{ color: "red" }}>* </span>Telepon/HP
        </div>
        <FormInputs
          placeholder="0812-xxx-xxx"
          className="frame-wrapper"
          name="phone_number"
          value={phoneNumber}
          onChange={onChange}
          isDisabled={isSaving}
          inputMode="numeric"
        />
        {phoneNumber && !isPhoneValid && (
          <small style={{ color: "red" }}>
            * Nomor telepon minimal {PHONE_MIN_LENGTH} digit
          </small>
        )}
        {errorMessage && (
          <small style={{ color: "red", display: "block", marginTop: "8px" }}>
            {errorMessage}
          </small>
        )}
        <div style={{ display: "flex", justifyContent: "end", marginTop: "24px" }}>
          <CustomButton
            label={isSaving ? "Menyimpan..." : "Simpan"}
            color={isSubmitDisabled ? "secondary-btn" : "primary-btn"}
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalPhoneNumber;
